import { useTranslation } from 'react-i18next'
import { Icon } from '@iconify/react'
import { Container, Card, Reveal } from '@/components/ui'

interface Testimonial {
  quote: string
  author: string
  role: string
}

export default function Testimonials() {
  const { t, i18n } = useTranslation()
  const items = t('home.testimonials.items', { returnObjects: true }) as Testimonial[]
  const isZh = i18n.language.startsWith('zh')
  const openQuote = isZh ? '「' : '\u201c'
  const closeQuote = isZh ? '」' : '\u201d'

  return (
    <section className="py-section-y px-section-x bg-surface" aria-labelledby="testimonials-title">
      <Container>
        <div className="text-center mb-8">
          <span className="section-title__tagline inline-block mb-3">
            {t('home.testimonials.tag')}
          </span>
          <h2
            id="testimonials-title"
            className="section-title__title text-3xl md:text-4xl lg:text-5xl text-ink"
          >
            {t('home.testimonials.title')}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-gap-cards">
          {items.map((tm, idx) => (
            <Reveal key={idx} delay={idx * 0.1}>
              <Card bordered className="h-full relative">
                {/* Quote icon */}
                <Icon
                  icon="lucide:quote"
                  className="text-accent opacity-30 absolute top-4 right-4"
                  style={{ fontSize: '3rem' }}
                />

                <p className="text-ink-soft leading-relaxed mb-6 mt-4">
                  {openQuote + tm.quote + closeQuote}
                </p>

                <div className="flex items-center gap-3 mt-auto">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary to-primary-dark flex items-center justify-center text-surface font-bold">
                    {tm.author.charAt(0)}
                  </div>
                  <div>
                    <p className="font-semibold text-ink">{tm.author}</p>
                    <p className="text-sm text-ink-muted">{tm.role}</p>
                  </div>
                </div>
              </Card>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  )
}